import script from "./UserProfileOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileOrders.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileOrders.vue?vue&type=style&index=0&id=7a722e76&scoped=true&lang=css"
import "./UserProfileOrders.vue?vue&type=style&index=1&id=7a722e76&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a722e76"]])

export default __exports__